module.exports = __webpack_public_path__ + "img/suncar.c6650840.png";